export const boardsTableBreakpoint = 700;
